import { createSelector } from 'reselect'
// import { selectDeviceTypeIsDesktop } from 'selectors/app'
import { emptyObj } from 'util/objects'
import * as UserPreferences from 'inbox/user/preferences'
import * as deviceTypes from 'constants/device_types'
import { selectCurrentUser } from './base'

export const selectPreferences = createSelector(
  selectCurrentUser,
  currentUser => {
    return currentUser.preferences || emptyObj
  }
)

export const selectPrefersReplyOpen = createSelector(
  selectPreferences,
  prefs => {
    return UserPreferences.repliesAsOpen(prefs)
  }
)

// Builds a boolean User preference selector
function preferenceSelector(prefName) {
  return createSelector(selectPreferences, (preferences = {}) => {
    return !!preferences[prefName]
  })
}

export const selectPrefersUnifiedInbox = preferenceSelector('unified_inbox')

export const selectPrefersAllMailboxesSectionVisible = preferenceSelector(
  'prefers_v2_show_all_mailboxes_section'
)

export const selectShowAvatarsInMessages = preferenceSelector(
  'show_avatars_in_messages'
)

export const selectShowKbSearchOnInboxEditor = preferenceSelector(
  'show_kb_search_on_inbox_editor'
)

export const selectPrefersAgentsCanMoveToInaccessibleMailboxes = preferenceSelector(
  'prefers_agents_can_move_to_inaccessible_mailboxes'
)

export const selectShouldUseSpeedyGroove = preferenceSelector('speedy_groove')

export const selectPrefersClassicView = createSelector(
  preferenceSelector('classic_view'),
  state => state.app && state.app.deviceType === deviceTypes.DESKTOP,
  (classicView, isDesktop) => classicView && isDesktop
)

export const selectAutoLoadFirstTicketInList = createSelector(
  selectPrefersClassicView,
  preferenceSelector('autoload_first_ticket_in_list'),
  (classicView, autoload) => !classicView && autoload
)

export const selectAutoAdvanceToNextTicketInList = createSelector(
  selectPrefersClassicView,
  preferenceSelector('autoadvance_to_next_ticket'),
  (classicView, advance) => !classicView && advance
)

export const selectPrefersOpenFolderOnTicketReply = createSelector(
  selectPrefersClassicView,
  preferenceSelector('open_folder_on_ticket_reply'),
  (classicView, openFolder) => {
    return classicView && openFolder
  }
)

export const selectPrefersOpenFolderOnNoteAdd = createSelector(
  selectPrefersClassicView,
  preferenceSelector('open_folder_on_note_add'),
  (classicView, openFolder) => {
    return classicView && openFolder
  }
)

export const selectPrefersOpenFolderOnTicketSave = createSelector(
  selectPrefersClassicView,
  preferenceSelector('open_folder_on_ticket_save'),
  (classicView, openFolder) => {
    return classicView && openFolder
  }
)

export const selectPreferredMailboxId = createSelector(
  selectCurrentUser,
  currentUser => {
    return (currentUser || {}).preferredMailboxId || ''
  }
)

// HACK (jscheel && msaspence): Account-level timezone preference is pulled in
// through the current user, even though it is account level.
export const selectAccountTimezone = createSelector(
  selectPreferences,
  preferences => {
    const { timezone: { account: { id } = {} } = {} } = preferences || {}
    return id
  }
)
